<template>
	<div style="position: relative; width: 100%; height: 100%;">
		<div id="d009" class="diagram" style="padding-bottom: 3rem;"></div>
		<div
			class="center"
			style="position: absolute; bottom: 0; left: 0; right: 0;"
		>
			<span class="dot primary"></span> {{ 'Totala tillgångar' | T }}
			<span class="dot bcLightGrey"></span> {{ 'Obeskattade reserver' | T }}
			<span class="dot result"></span> {{ 'Eget kapital' | T }}
		</div>
	</div>
</template>

<script>
/* tslint:disable */
import Highcharts from "highcharts";
import Vue from "vue";
import { colors } from "@/config";

export default {
	name: "D009",
	components: {},
	props: {
		balance: Object,
	},

	mounted() {
		this.chart = new Highcharts.chart({
			chart: {
				type: "column",
				renderTo: "d009",
				backgroundColor: "transparent",
			},

			credits: {
				enabled: false,
			},

			title: {
				text: "",
			},

			legend: {
				enabled: false,
			},

			colors: [colors.Primary, colors.LightGrey, colors.Green, colors.Red],

			xAxis: {
				categories: this.balance.sheets
					.map((s) => s.DATE_TO.substr(0, 4))
					.reverse(),
				labels: {
					style: { fontSize: "1rem", color: colors.Black, },
				},
			},

			yAxis: {
				opposite: true,
				allowDecimals: false,
				title: {
					text: "",
				},
				labels: {
					formatter() {
						return Vue.options.filters.KR(this.value);
					},
					style: { fontSize: "1rem", color: colors.DarkGrey, },
				},
				tickPixelInterval: 150,
				gridLineColor: colors.LightGrey,
				plotLines: [{
					color: colors.Black,
					width: 2,
					value: 0,
					zIndex: 2,
				}],
			},

			tooltip: {
				formatter: function() {
					return (
						"<b>" + this.series.name + "<br>" + Vue.options.filters.TKR(this.y)
					);
				},
				style: { fontSize: "1.25rem" },
				backgroundColor: colors.Light,
			},

			plotOptions: {
				column: {
					stacking: "normal",
					borderColor: colors.DarkGrey,
				},
			},

			series: [
				{
					name: Vue.prototype.$t("Summa tillgångar"),
					data: this.balance.sheets
						.map((s, i) =>
							i === 0 ? { y: s.L, color: colors.Secondary } : s.L
						)
						.reverse(),
					stack: "intakt",
				},
				{
					name: Vue.prototype.$t("Obeskattade reserver"),
					data: this.balance.sheets.map((s) => s.N).reverse(),
					stack: "kostnad",
				},
				{
					name: Vue.prototype.$t("Eget kapital"),
					data: this.balance.sheets.map((s) => (s.M > 0 ? s.M : 0)).reverse(),
					stack: "kostnad",
				},
				{
					name: Vue.prototype.$t("Negativt eget kapital"),
					data: this.balance.sheets.map((s) => (s.M < 0 ? s.M : 0)).reverse(),
					stack: "kostnad",
				},
			],
		});

		//this.chart.setSize(640, 420);
	},
};
</script>

<style scoped lang="scss">
.dot {
	height: 2rem;
	width: 2rem;
	border-radius: 50%;
	display: inline-block;
}

.primary {
	background: linear-gradient(
		-45deg,
		get("colors.Secondary"),
		get("colors.Secondary") 50%,
		get("colors.Primary") 50%
	);
	border-radius: 50%;
}

.result {
	background: linear-gradient(
		-45deg,
		col("colors.Negative"),
		col("colors.Negative") 50%,
		col("colors.Positive") 50%
	);
	border-radius: 50%;
}

.center {
	font-size: 1.2rem;
}
</style>
